import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { Transfer } from '../types';

export function useTransferHistory() {
  return useQuery({
    queryKey: queryKeys.transfers.history,
    queryFn: () => apiClient.get<Transfer[]>('/transfers/history'),
  });
}
